/**
 * Component: Employee list
 * Requires packery for the filtering
 */

var ed = ed || {};

ed.employeeList = new function(){
    var employeeListContainer = $('#employee-list-container'),
        employeeListFilters = $('#employee-list-filters'),
        employeeListFiltersGroup = $('.employee-list-filters__group', employeeListFilters),
        employeeListFiltersDepartment = $('.employee-list-filters__department', employeeListFilters),
        employeeListFiltersGroupsDepartments = $('.employee-list-filters-groups-content-departments', employeeListFilters),
        employeeListFiltersAll = $('#employee-list-filters-all'),
        employeeContainer = '.employee-container',
        selectedFilters = {
            'group': '',
            'department': ''
        };

    /**
     * Init function
     */
    this.init = function() {
        var theSelected = employeeListFilters.find('.employee-list-filters__group.selected:not(#employee-list-filters-all)');

        initPackery();
        filterGroup();
        filterDepartment();
        resetAllFilters();

        if(theSelected) {
            theSelected.trigger('click');
        }
    };

    /**
     * Employee list packery setup
     */
    function initPackery() {
        employeeListContainer.packery({
            itemSelector: employeeContainer,
            gutter: 0
        });
    }

    /**
     * Filter group
     * Filters based on group (country)
     */
    function filterGroup() {

        employeeListFiltersGroup.not(employeeListFiltersAll).on('click', function(){
            var filterGroup = $(this).data('filter-group'),
                active = selectedFilters.group === filterGroup;

            // Remove all selected on all groups
            employeeListFiltersGroup.removeClass('selected');

            // If the clicked group isn't active
            if(!active) {
                // Set the filter
                selectedFilters.group = filterGroup;

                // Set the selected class on the button
                $(this).addClass('selected');

                // Remove all departments selected class
                employeeListFiltersGroupsDepartments.removeClass('selected');

                // Reset the filter
                selectedFilters.department = '';
                // Remove the selected class on the button
                $('.employee-list-filters__department').removeClass('selected');

                // Find the correct one, based on the group value, and show it
                employeeListFiltersGroupsDepartments
                    .filter(function () { return $(this).data('filter-group') === filterGroup; })
                    .addClass('selected');
            }
            // If the clicked group is active
            else {
                // Reset the filter
                selectedFilters.group = '';

                // Remove the selected class on the button
                $('.employee-list-filters__department').removeClass('selected');

                // Remove all departments selected class
                employeeListFiltersGroupsDepartments.removeClass('selected');
            }

            // Fire the filter function
            filterList();
        });

    }

    /**
     * Filter department
     * Filters based on department
     */
    function filterDepartment() {
        employeeListFiltersDepartment.on('click', function(){
            var filterDepartment = $(this).data('filter-department');
            var active = selectedFilters.department === filterDepartment;
            // Remove all selected on all departments
            employeeListFiltersDepartment.removeClass('selected');

            // If the clicked department isn't active
            if(!active) {
                // Set the filter
                selectedFilters.department = filterDepartment;
                // Set the selected class on the button
                $(this).addClass('selected');
            }
            // If the clicked department is active
            else {
                // Reset the filter
                selectedFilters.department = '';

                // // Remove the selected class on the button
                $(this).removeClass('selected');
            }

            // Fire the filter function
            filterList();
        });
    }

    function resetAllFilters() {
        employeeListFiltersAll.on('click', function(){
            // Remove all selected classes
            employeeListFiltersGroup.not(employeeListFiltersAll).removeClass('selected');
            employeeListFiltersDepartment.removeClass('selected');
            employeeListFiltersGroupsDepartments.removeClass('selected');

            // Reset the filters
            selectedFilters.group = '';
            selectedFilters.department = '';

            $(this).addClass('selected');

            // Fire the filter function
            filterList();
        });
    }

    function filterList() {
        $(employeeContainer, employeeListContainer).each(function(){
            $(this).show();
            if (selectedFilters.group !== '') {
                if (selectedFilters.department !== "") {
                    if ($(this).data('filter-group').indexOf(selectedFilters.group) != -1 && $(this).data('filter-department').indexOf(selectedFilters.department) != -1) {
                        $(this).show();
                    }
                    else {
                        $(this).hide();
                    }
                }
                else {
                    if ($(this).data('filter-group').indexOf(selectedFilters.group) != -1) {
                        $(this).show();
                    }
                    else {
                        $(this).hide();
                    }
                }
            }
        });

        // Relayout
        employeeListContainer.packery();
    }

};
